import * as React from 'react';
import { Searchbar } from 'react-unity';
import { TextPassage } from '../common/components/TextPassage';
import { TextLink } from '../common/components/TextLinkNew';
import { Toolbar } from '../common/components/Toolbar';
import { ToolbarItem } from '../common/components/Toolbar';
import { Button } from '../common/components/Button';
import { Alert, AlertVariantType } from '../common/components/Alert';
import { TextInput } from '../common/form-controls/TextInput';
import { Grid } from '../common/layouts/Grid';
import { Icon } from '../common/components/Icon';
import { ProgressBar } from '../common/components/ProgressBar';
import { Table } from '../common/components/Table';
import SectionHomeWrapper from '../common/wrappers/SectionHomeWrapper';
import '../common/wrappers/SectionHomeWrapper.css';
import AlibabaCloudService from '../../services/AlibabaCloudService';
import AlibabaRamUser from '../../models/AlibabaRamUser';
import AlibabaRamResetPw from '../../models/AlibabaRamResetPw';
import './AlibabaCloudHome.css';
import ConfirmModal from '../common/modals/ConfirmModal';
import StandardModal from '../common/modals/StandardModal';
import Paginator from '../common/tables/Paginator';

interface AlibabaCloudHomeState {
	actionsEnabled: boolean;
	filteredAccounts: AlibabaRamUser[];
	accountsOnPage: AlibabaRamUser[];
	searchText: string;
	resetPasswordModalVisible: boolean;
	isLoading: boolean;
	alertVisible: boolean;
	alertText: string;
	alertType: AlertVariantType;
	myRamUsers: AlibabaRamUser[];
	resetPasswordConfirmVisible: boolean;
	selectedRamUser: AlibabaRamUser;
	approvalLoading: boolean;
	refetchAlertVisible: boolean;
	approvalResultModalVisible: boolean;
	approvalResultData: AlibabaRamResetPw;
}

export default class AlibabaCloudHome extends React.Component<{}, AlibabaCloudHomeState> {
	alibabaClouService: AlibabaCloudService;

	timeoutId: NodeJS.Timeout;

	actionRef: React.RefObject<HTMLBaseElement>;

	constructor(props: any) {
		super(props);

		this.alibabaClouService = new AlibabaCloudService();
		this.timeoutId = undefined;
		this.actionRef = React.createRef();

		this.state = {
			filteredAccounts: [],
			accountsOnPage: [],
			searchText: '',
			resetPasswordModalVisible: false,
			isLoading: true,
			alertVisible: false,
			alertText: '',
			alertType: 'default',
			actionsEnabled: true,
			myRamUsers: [],
			resetPasswordConfirmVisible: false,
			selectedRamUser: undefined,
			approvalLoading: false,
			refetchAlertVisible: false,
			approvalResultModalVisible: false,
			approvalResultData: undefined,
		};
	}

	async componentDidMount() {
		/*this.setState({
			searchDropdownStatus: authenticatedUser.isInRole(UserRole.CloudAccountAdmin)
				? 'Submitted'
				: 'All'
		});*/

		try {
			await this.updateState();
		} catch (error) {
			const HTTP_INTERNAL_SERVER_ERROR = 500;
			if (error.status === HTTP_INTERNAL_SERVER_ERROR) {
				this.handleError(error, 'Error gathering Ram accounts data');
			}
		}
		this.setState({ isLoading: false });
	}

	handleRefreshClick = async () => {
		this.setState({ isLoading: true });
		try {
			await this.updateState();
		} catch (error) {
			const HTTP_INTERNAL_SERVER_ERROR = 500;
			if (error.status === HTTP_INTERNAL_SERVER_ERROR) {
				this.handleError(error, 'Error refreshing Ram accounts data');
			}
		}
		this.setState({ isLoading: false });
	};

	updateState = async () => {
		let myRamUsers = await this.alibabaClouService.getRamUserEmail();

		this.setState(
			{
				filteredAccounts: myRamUsers,
				myRamUsers,
			},
			() => {
				/*if (this.state.searchText !== '') {
				this.handleSearchTextChange(this.state.searchText);
			}
			if (this.state.searchDropdownStatus !== 'All') {
				this.handleStatusDropdownChange(this.state.searchDropdownStatus);
			}*/
			}
		);
	};

	openRamUserRequest = () => {
		const baseUrl = process.env.REACT_APP_SERVICENOW_BASE_URL;
		const url = `${baseUrl}/ec?id=sc_cat_item&table=sc_cat_item&sys_id=ed3e56bc1b277950992584415b4bcb24&recordUrl=com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1&sysparm_id=ed3e56bc1b277950992584415b4bcb24`;
		window.open(url, '_blank');
	};

	handleSearchTextChange = (e) => {
		const searchText = e.target?.value.trim() ?? e;

		this.applyFilters(searchText);
	};

	applyFilters = (searchText) => {
		const { myRamUsers } = this.state;
		const normalizedSearchText = searchText.toLowerCase().trim();

		let filteredAccounts = this.state.myRamUsers.filter((account) => {
			const matchesAccountName = account.account_name.toLowerCase().includes(normalizedSearchText);
			const matchesAccountOwner = account.account_owner.toLowerCase().includes(normalizedSearchText);
			const matchesUserDisplayName = account.user_display_name.toLowerCase().includes(normalizedSearchText);

			return matchesAccountName || matchesAccountOwner || matchesUserDisplayName;
		});

		this.setState((prev) => ({
			filteredAccounts,
			searchText,
		}));
	};

	handleSubmitAlert = (alertText: string) => {
		this.setState({
			alertVisible: true,
			alertType: 'default',
			alertText,
			actionsEnabled: true,
		});
	};

	handleSuccessAlert = (alertText: string) => {
		this.setState(
			(_) => ({
				alertVisible: true,
				alertType: 'success',
				alertText,
				actionsEnabled: true,
			}),
			() => {
				this.handleSetTimeout();
			}
		);
	};

	handlePasswordResetRequest = async () => {
		this.setState({
			resetPasswordConfirmVisible: false,
			approvalLoading: true,
			refetchAlertVisible: false,
		});

		const { account_id, user_principal_name } = this.state.selectedRamUser;

		const timeoutPromise = new Promise<AlibabaRamResetPw>((_, reject) =>
			setTimeout(() => reject(new Error('Request timed out after 30 seconds')), 30000)
		);

		try {
			this.handleSubmitAlert('Submitting request...');

			const accountPwReset = await Promise.race([
				this.alibabaClouService.getResetPassword(account_id, user_principal_name),
				timeoutPromise,
			]);

			this.setState({
				approvalLoading: false,
				approvalResultModalVisible: true,
				approvalResultData: accountPwReset,
			});
		} catch (error) {
			this.setState({ approvalLoading: false });
			if (error.message !== 'Request timed out after 30 seconds') {
				this.handleError(error);
			}
			this.setState({ refetchAlertVisible: true });
		}
	};

	handleSubmit = async (alertText: string) => {
		this.setState({
			alertVisible: true,
			alertType: 'default',
			alertText,
			actionsEnabled: false,
		});

		this.handleSetTimeout();
	};

	handleSuccess = async (alertText: string) => {
		this.setState({
			alertVisible: true,
			alertType: 'success',
			alertText,
			actionsEnabled: true,
			isLoading: true,
		});

		this.handleSetTimeout();

		await this.updateState();
		this.setState({ isLoading: false });
	};

	handleError = async (
		error,
		message = 'Your request could not be completed at this time. Please try again later.'
	) => {
		this.setState({
			alertVisible: true,
			alertType: 'error',
			alertText: error.body?.message ?? message,
			isLoading: true,
			actionsEnabled: true,
		});

		this.handleSetTimeout();
		await this.updateState();
		this.setState({ isLoading: false });

		throw error;
	};

	handleAlertClose = () => {
		this.setState({
			alertVisible: false,
			alertText: '',
			alertType: 'default',
		});
	};

	handleSetTimeout = () => {
		if (this.timeoutId !== undefined) {
			window.clearTimeout(this.timeoutId);
		}

		this.timeoutId = setTimeout(this.handleAlertClose, 10000);
	};

	render() {
		const tableRows = [];
		const statusRows = [];
		this.state.accountsOnPage.forEach((account) => {
			const account_name = account.account_name;
			const account_id = account.account_id;
			const account_owner = account.account_owner;
			//const owner_email = account.owner_email;
			//const user_id = account.user_id;
			//const user_display_name = account.user_display_name;
			const user_type = account.user_type;
			const user_principal_name = account.user_principal_name;
			//const user_owner = account.user_owner;

			tableRows.push(
				<Table.Row key={account.account_id}>
					<div className="em-u-text-align-center">{account_name}</div>
					<div className="em-u-text-align-center">{account_owner}</div>
					<div className="em-u-text-align-center">{user_principal_name}</div>
					<div className="em-u-text-align-center">{user_type}</div>
					<div className="em-u-text-align-center">
						<Button
							style={{ zIndex: 0 }}
							variant="primary"
							size="small"
							disabled={user_type === 'API'}
							onClick={() =>
								this.setState({
									resetPasswordConfirmVisible: true,
									selectedRamUser: account,
								})
							}
						>
							Reset Password
						</Button>
					</div>
				</Table.Row>
			);
		});

		return (
			<SectionHomeWrapper title="Alibaba Ram User Management">
				<TextPassage>
					<p>
						For more information, please follow{' '}
						<TextLink target="_blank" external href="https://appwiki.xom.cloud/">
							this link
						</TextLink>
					</p>
				</TextPassage>
				<br />

				<ConfirmModal
					visible={this.state.resetPasswordConfirmVisible}
					title={`Reset password for '${this.state.selectedRamUser?.user_display_name}'?`}
					question={`Are you sure you want to reset the password for ${this.state.selectedRamUser?.user_principal_name}? This action cannot be undone.`}
					confirmButton={{ label: 'Confirm Reset' }}
					onConfirm={this.handlePasswordResetRequest}
					onCancel={() => this.setState({ resetPasswordConfirmVisible: false })}
				/>

				{this.state.approvalLoading && (
					<StandardModal show={true} onDismiss={() => {}} title="Processing" blockOverlayClick={true}>
						<ProgressBar indeterminate label={'Fetching information'} />
					</StandardModal>
				)}

				{this.state.refetchAlertVisible && (
					<Alert
						variant="error"
						onClose={() => this.setState({ refetchAlertVisible: false })}
						body="The request took too long to complete. Please try submitting again."
					/>
				)}

				<StandardModal
					show={this.state.approvalResultModalVisible}
					onDismiss={() => {
						this.setState({ approvalResultModalVisible: false });
					}}
					title={this.state.approvalResultData?.['UserPrincipalName'] || 'One Time Password'}
					kicker="One Time Password for:"
					footer={
						<Grid variant="2up">
							<Grid.Item>
								<Button
									variant="secondary"
									onClick={() => {
										this.setState({ approvalResultModalVisible: false });
									}}
								>
									Close
								</Button>
							</Grid.Item>
							<Grid.Item>
								<Button
									variant="primary"
									onClick={() => {
										const input = document.getElementById('otp-input') as HTMLInputElement;
										if (input) {
											input.select();
											document.execCommand('copy');
										}
										this.setState({ approvalResultModalVisible: false });
									}}
								>
									Copy and Close
								</Button>
							</Grid.Item>
						</Grid>
					}
				>
					<div id="approval-result-modal-body">
						<TextInput
							readOnly
							value={this.state.approvalResultData?.['One-Time-Password'] ?? ''}
							id="otp-input"
							type="text"
							label={'One Time Password:'}
							onChange={() => {}}
						/>
						<p style={{ color: 'red', fontWeight: 'bold', marginTop: '8px' }}>
							⚠️ This one-time password will only be visible once. Please copy it now.
						</p>
					</div>
				</StandardModal>

				{this.state.isLoading ? (
					<ProgressBar indeterminate label="Loading your accounts..." />
				) : (
					<Table
						header={
							<Toolbar>
								<ToolbarItem className="searchbar-width">
									<Searchbar
										buttonProps={{ onClick: (e) => e.preventDefault() }}
										inputProps={{
											value: this.state.searchText,
											onChange: (e) => this.handleSearchTextChange(e),
											placeholder: 'Search (i.e. Account Name, Account Owner, User Name)',
										}}
									/>
								</ToolbarItem>
								<ToolbarItem>
									<Button variant="secondary" size="small" onClick={this.handleRefreshClick}>
										<Icon icon="refresh" size="small" />
										<span> Refresh</span>
									</Button>
								</ToolbarItem>
								<ToolbarItem right>
									<Button variant="primary" size="small" onClick={this.openRamUserRequest}>
										<Icon icon="plus-filled" size="small" />
										&nbsp; Request Ram User
									</Button>
								</ToolbarItem>
							</Toolbar>
						}
						footer={
							<Paginator
								data={this.state.filteredAccounts}
								onPageChange={(accounts: AlibabaRamUser[]) => {
									this.setState({
										accountsOnPage: accounts,
									});
								}}
							/>
						}
					>
						<Table.Head>
							<Table.Head.Row>
								<Table.Head.Cell>Account Name</Table.Head.Cell>
								<Table.Head.Cell className="em-u-text-align-center">Account Owner</Table.Head.Cell>
								<Table.Head.Cell className="em-u-text-align-center">
									User Principal Name
								</Table.Head.Cell>
								<Table.Head.Cell className="em-u-text-align-center">User Type</Table.Head.Cell>
								<Table.Head.Cell className="em-u-text-align-center">Action</Table.Head.Cell>
							</Table.Head.Row>
						</Table.Head>
						<Table.Body>{tableRows}</Table.Body>
					</Table>
				)}
			</SectionHomeWrapper>
		);
	}
}
